module.exports = __webpack_public_path__ + "static/img/uneven_skintone-01.0b8c909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/uneven_skintone-01.jpg
// module id = 297
// module chunks = 1